<template>
  <div v-if="hasAnyPermission('manufacture-view')" class="py-4 container-fluid">
    <ToastPrime position="bottom-left" />
    <div class="card border-0" style="height: calc(100vh - 120px); display: flex; flex-direction: column;">
      <div
        class="card-header bg-white py-3 d-flex flex-wrap align-items-center justify-content-between gap-3 border-bottom">
        <div class="d-flex align-items-center gap-2">
          <h5 class="mb-0 fw-bold">Manufacturer List</h5>
        </div>
        <div class="d-flex flex-wrap gap-2 flex-grow-1 justify-content-center">
          <IconField class="search-field">
            <InputIcon>
              <i class="pi pi-search" />
            </InputIcon>
            <InputText
v-model="table.search" type="text" size="small" placeholder="Search Manufacturer..."
              class="rounded-pill" style="min-width: 500px;" @keyup="filter" />
          </IconField>
        </div>
        <div class="d-flex flex-wrap gap-2 align-items-center">
          <SelectPrime v-if="hasClientData" v-model="table.clientFilter" :options="clientFilterOptions" option-label="label" option-value="value" placeholder="Filter Client" class="rounded-pill" size="small" style="width: auto;">
            <template #value="slotProps">
              <div class="d-flex align-items-center">
                <i class="pi pi-filter me-2" :class="slotProps.value ? 'text-primary' : 'text-muted'" style="font-size: 0.8rem;" />
                <div :class="{ 'text-muted': !slotProps.value }">{{ slotProps.value || slotProps.placeholder }}</div>
              </div>
            </template>
          </SelectPrime>
          <button v-if="hasAnyPermission('manufacture-create')" type="button" class="mx-1 mb-0 btn btn-sm btn-primary" @click="openAddModal">Add</button>
        </div>
      </div>
      <div style="flex: 1; overflow-y: auto;">
        <DataTable
:value="table.onLoad ? dummyRows : table.data" removable-sort scrollable scroll-height="flex"
          table-style="min-width: 100%; width: max-content;">
          <Column field="client" header="Client" header-class="bg-light text-dark text-nowrap" sortable>
            <template v-if="table.onLoad" #body>
              <Skeleton></Skeleton>
            </template>
            <template v-else #body="slotProps">
              {{ slotProps.data && slotProps.data.client ? slotProps.data.client : '' }}
            </template>
          </Column>
          <Column field="code" header="Code" header-class="bg-light text-dark text-nowrap" sortable>
            <template v-if="table.onLoad" #body>
              <Skeleton></Skeleton>
            </template>
            <template v-else #body="slotProps">
              {{ slotProps.data && slotProps.data.code ? slotProps.data.code : '' }}
            </template>
          </Column>
          <Column field="name" header="Name" header-class="bg-light text-dark text-nowrap" sortable>
            <template v-if="table.onLoad" #body>
              <Skeleton></Skeleton>
            </template>
            <template v-else #body="slotProps">
              {{ slotProps.data && slotProps.data.name ? slotProps.data.name : '' }}
            </template>
          </Column>
          <Column field="country" header="Country" header-class="bg-light text-dark text-nowrap" sortable>
            <template v-if="table.onLoad" #body>
              <Skeleton></Skeleton>
            </template>
            <template v-else #body="slotProps">
              {{ slotProps.data && slotProps.data.country ? slotProps.data.country : '' }}
            </template>
          </Column>
          <Column field="business_type" header="Business Type" header-class="bg-light text-dark text-nowrap" sortable>
            <template v-if="table.onLoad" #body>
              <Skeleton></Skeleton>
            </template>
            <template v-else #body="slotProps">
              {{ slotProps.data && slotProps.data.business_type ? slotProps.data.business_type : '' }}
            </template>
          </Column>
          <Column field="address" header="Address" header-class="bg-light text-dark text-nowrap" sortable>
            <template v-if="table.onLoad" #body>
              <Skeleton></Skeleton>
            </template>
            <template v-else #body="slotProps">
              {{ slotProps.data && slotProps.data.address ? slotProps.data.address : '' }}
            </template>
          </Column>
          <Column field="business_phone" header="Business Phone" header-class="bg-light text-dark text-nowrap" sortable>
            <template v-if="table.onLoad" #body>
              <Skeleton></Skeleton>
            </template>
            <template v-else #body="slotProps">
              {{ slotProps.data && slotProps.data.business_phone ? slotProps.data.business_phone : '' }}
            </template>
          </Column>
          <Column field="fax" header="Fax" header-class="bg-light text-dark text-nowrap" sortable>
            <template v-if="table.onLoad" #body>
              <Skeleton></Skeleton>
            </template>
            <template v-else #body="slotProps">
              {{ slotProps.data && slotProps.data.fax ? slotProps.data.fax : '' }}
            </template>
          </Column>
          <Column field="mobile_phone" header="Mobile Phone" header-class="bg-light text-dark text-nowrap" sortable>
            <template v-if="table.onLoad" #body>
              <Skeleton></Skeleton>
            </template>
            <template v-else #body="slotProps">
              {{ slotProps.data && slotProps.data.mobile_phone ? slotProps.data.mobile_phone : '' }}
            </template>
          </Column>
          <Column field="email" header="Email" header-class="bg-light text-dark text-nowrap" sortable>
            <template v-if="table.onLoad" #body>
              <Skeleton></Skeleton>
            </template>
            <template v-else #body="slotProps">
              {{ slotProps.data && slotProps.data.email ? slotProps.data.email : '' }}
            </template>
          </Column>
          <Column field="contact_person" header="Contact Person" header-class="bg-light text-dark text-nowrap" sortable>
            <template v-if="table.onLoad" #body>
              <Skeleton></Skeleton>
            </template>
            <template v-else #body="slotProps">
              {{ slotProps.data && slotProps.data.contact_person ? slotProps.data.contact_person : '' }}
            </template>
          </Column>
          <Column field="notes" header="Notes" header-class="bg-light text-dark text-nowrap" sortable>
            <template v-if="table.onLoad" #body>
              <Skeleton></Skeleton>
            </template>
            <template v-else #body="slotProps">
              {{ slotProps.data && slotProps.data.notes ? slotProps.data.notes : '' }}
            </template>
          </Column>
          <!-- Created By -->
          <Column field="created_by" header="Created By" sortable header-class="bg-light text-dark">
            <template v-if="table.onLoad" #body>
              <Skeleton />
            </template>

            <template v-else #body="slotProps">
              {{ slotProps.data?.created_by || '-' }}
            </template>
          </Column>

          <!-- Updated By -->
          <Column field="updated_by" header="Updated By" sortable header-class="bg-light text-dark">
            <template v-if="table.onLoad" #body>
              <Skeleton />
            </template>

            <template v-else #body="slotProps">
              {{ slotProps.data?.updated_by || '-' }}
            </template>
          </Column>
          <Column field="created_at" header="Created At" header-class="bg-light text-dark text-nowrap" sortable>
            <template v-if="table.onLoad" #body>
              <Skeleton></Skeleton>
            </template>
            <template v-else #body="slotProps">
              {{ slotProps.data && slotProps.data.created_at ? formatDate(slotProps.data.created_at) : '' }}
            </template>
          </Column>
          <Column header="Actions" header-class="bg-light">
            <template v-if="table.onLoad" #body>
              <Skeleton />
            </template>
            <template v-else #body="slotProps">
              <div class="text-nowrap">
                <ButtonPrime
v-if="hasAnyPermission('manufacture-update')"
v-tooltip.bottom="'Update'" icon="pi pi-pencil" outlined rounded size="small" class="me-2"
                  @click="openEditModal(slotProps.data.id)" />
                <ButtonPrime
v-if="hasAnyPermission('manufacture-delete')"
v-tooltip.bottom="'Delete'" icon="pi pi-trash" outlined rounded severity="danger"
                  size="small" @click="deleteItem(slotProps.data.id)" />
              </div>
            </template>
          </Column>
          <template #empty>
            <div style="text-align: center; padding: 40px 0;">
              <img src="/no_data.png" alt="No Data" style="max-width: 330px; opacity: 0.7; margin-bottom: 0;" />
              <div style="color: #888; font-size: 1.1em; font-weight: 500;">
                No Data
              </div>
            </div>
          </template>
        </DataTable>
      </div>
      <div class="card-footer pb-0 d-flex justify-content-between align-items-center">
        <BasePagination
v-model="table.page.current_pages" :page-count="table.page?.total_pages || 1" size="sm"
          @click="changePage()" />
        <p>
          {{ (table.page.current_pages - 1) * table.page.per_pages + table.data.length }} of {{ table.total }}
        </p>
      </div>
    </div>
    <DialogPrime v-model:visible="modal.visible" modal style="width: 60rem; margin: 10px;" class="manufacturer-modal">
      <template #header>
        <div class="d-flex align-items-center gap-3">
          <div>
            <h5 class="mb-0 fw-bold text-dark">{{ modal.title }}</h5>
          </div>
        </div>
      </template>
      <div class="row g-4">
        <div class="col-12">
          <div class="row g-3">
            <div class="col-md-4">
              <label for="code" class="form-label fw-semibold">Code <span class="text-danger">*</span></label>
              <InputText
id="code" v-model="modal.data.code" placeholder="Code" :invalid="!!modal.errorMessage['code']"
                :disabled="!!modal.editId" fluid />
            </div>
            <div class="col-md-8">
              <label for="name" class="form-label fw-semibold">Manufacturer Name <span
                  class="text-danger">*</span></label>
              <InputText
id="name" v-model="modal.data.name" placeholder="Full Manufacturer Name"
                :invalid="!!modal.errorMessage['name']" fluid />
            </div>
            <div class="col-md-6">
              <label for="business_type" class="form-label fw-semibold">Business Type</label>
              <InputText
id="business_type" v-model="modal.data.business_type"
                placeholder="e.g. Distributor, Factory" :invalid="!!modal.errorMessage['business_type']" fluid />
            </div>
            <div class="col-md-6">
              <label for="country" class="form-label fw-semibold">Country</label>
              <InputText
id="country" v-model="modal.data.country" placeholder="Country Name"
                :invalid="!!modal.errorMessage['country']" fluid />
            </div>
          </div>
        </div>

        <!-- Section: Contact Details -->
        <div class="col-12">
          <div class="row g-3">
            <div class="col-md-4">
              <label for="contact_person" class="form-label fw-semibold">Contact Person</label>
              <InputText
id="contact_person" v-model="modal.data.contact_person" placeholder="Name"
                :invalid="!!modal.errorMessage['contact_person']" fluid />
            </div>
            <div class="col-md-4">
              <label for="email" class="form-label fw-semibold">Email Address</label>
              <InputText
id="email" v-model="modal.data.email" placeholder="example@mail.com"
                :invalid="!!modal.errorMessage['email']" fluid />
            </div>
            <div class="col-md-4">
              <label for="mobile_phone" class="form-label fw-semibold">Mobile Phone</label>
              <InputText
id="mobile_phone" v-model="modal.data.mobile_phone" placeholder="+62..."
                :invalid="!!modal.errorMessage['mobile_phone']" fluid />
            </div>
            <div class="col-md-6">
              <label for="business_phone" class="form-label fw-semibold">Business Phone</label>
              <InputText
id="business_phone" v-model="modal.data.business_phone"
                placeholder="Office Phone" :invalid="!!modal.errorMessage['business_phone']" fluid />
            </div>
            <div class="col-md-6">
              <label for="fax" class="form-label fw-semibold">Fax</label>
              <InputText
id="fax" v-model="modal.data.fax" placeholder="Fax Number"
                :invalid="!!modal.errorMessage['fax']" fluid />
            </div>
          </div>
        </div>

        <!-- Section: Address & Notes -->
        <div class="col-12">
          <div class="row g-3">
            <div class="col-md-6">
              <label for="address" class="form-label fw-semibold">Full Address</label>
              <PrimeTextarea
id="address" v-model="modal.data.address" placeholder="Enter complete address..." rows="3"
                :invalid="!!modal.errorMessage['address']" fluid />
            </div>
            <div class="col-md-6">
              <label for="notes" class="form-label fw-semibold">Additional Notes</label>
              <PrimeTextarea
id="notes" v-model="modal.data.notes" placeholder="Any extra information..." rows="3"
                :invalid="!!modal.errorMessage['notes']" fluid />
            </div>
          </div>
        </div>
      </div>
      <template #footer>
        <div class="d-flex justify-content-end gap-2 pt-3 border-top w-100 mt-2 px-1">
          <ButtonPrime
type="button" label="Cancel" severity="danger" raised size="small" class="px-4"
            @click="closeModal()" />
          <ButtonPrime
type="button" severity="contrast" raised size="small" :disabled="modal.onLoading" label="Save Manufacturer"
            class="px-4" @click="save()">
            <template v-if="modal.onLoading" #icon>
              <i class="fas fa-spinner fa-spin me-2"></i>
            </template>
          </ButtonPrime>
        </div>
      </template>
    </DialogPrime>
  </div>
  <NoAccess v-else />
</template>

<script>
import { mapState } from "vuex";
import BasePagination from "@/components/BasePagination.vue";
import NoAccess from "@/components/NoAccess.vue";
import moment from "moment";
import api from "@/helpers/api";
import manufacturerService from "@/services/generalMasterData/manufacturerService";
import clientService from "@/services/generalMasterData/clientService";
export default {
  components: {
    BasePagination,
    NoAccess,
  },
  computed: {
    ...mapState({
      authUserPermissions: (state) => state.auth.userHasPermissions || [],
    }),
    hasClientData() {
      return this.table.clientOptions.length > 0 && this.companyCode === 'MIND-ID';
    },
    clientFilterOptions() {
      const options = this.table.clientOptions.map(c => ({
        label: c.code || c.value || c.label || c,
        value: c.code || c.value || c
      }));
      options.unshift({ label: "All Clients", value: null });
      return options;
    },
  },
  data() {
    return {
      clientCode: '',
      companyCode: '',
      table: {
        onLoad: true,
        search: this.$route.query.search || "",
        clientFilter: this.$route.query.client || null,
        clientOptions: [],
        total: 0,
        data: [],
        limit: 100,
        page: {
          current_pages: 1,
          per_pages: 100,
          total_pages: 1,
        },
        loadTimeout: null,
      },
      dummyRows: Array.from({ length: 10 }, () => ({})),
      modal: {
        visible: false,
        data: {
          code: '',
          name: '',
          country: '',
          business_type: '',
          address: '',
          business_phone: '',
          fax: '',
          mobile_phone: '',
          email: '',
          contact_person: '',
          notes: ''
        },
        errorMessage: {},
        onLoading: false,
        title: '',
        editId: null,
      },
    };
  },
  watch: {
    "table.clientFilter": { handler() { this.syncUrlAndGet(); } },
  },
  mounted() {
    const userAuth = JSON.parse(localStorage.getItem('userAuth') || '{}');
    this.clientCode = userAuth?.user?.client_code || '';
    this.companyCode = userAuth?.user?.company_code || '';
    if (this.hasAnyPermission('manufacture-view')) {
      this.getClients();
      this.get();
    }
  },
  methods: {
    hasAnyPermission(...perms) {
      return perms.some((p) => this.authUserPermissions.includes(p));
    },
    async getClients() {
      try {
        const response = await api(this, clientService.list({ limit: 1000 }), false);
        this.table.clientOptions = response.data?.data || [];
      } catch (error) {
        this.table.clientOptions = [];
      }
    },
    syncUrlAndGet() {
      this.$router.push({
        query: {
          ...(this.table.search ? { search: this.table.search } : {}),
          ...(this.table.clientFilter ? { client: this.table.clientFilter } : {}),
        },
      });
      this.table.page.current_pages = 1;
      this.get();
    },
    async get() {
      this.table.onLoad = true;
      try {
        const response = await api(
          this,
          manufacturerService.list({
            search: this.table.search,
            client: this.companyCode === 'MIND-ID' ? this.table.clientFilter : this.clientCode,
            limit: this.table.limit,
            page: this.table.page.current_pages,
          }),
          false
        );
        const paged = response.data || {};
        this.table.data = paged.data || [];
        this.table.total = paged.total || this.table.data.length;
        this.table.page.total_pages = paged.last_page || 1;
        this.table.page.current_pages = paged.current_page || 1;
        this.table.page.per_pages = paged.per_page || this.table.limit;
      } catch (error) {
        this.table.data = [];
        this.table.total = 0;
        this.table.page.total_pages = 1;
      } finally {
        this.table.onLoad = false;
      }
    },
    filter() {
      clearTimeout(this.table.loadTimeout);
      this.table.loadTimeout = setTimeout(() => {
        this.syncUrlAndGet();
      }, 500);
    },
    changePage() {
      this.get();
    },
    formatDate(date) {
      return date ? moment(date).format("DD MMMM YYYY, HH:mm") : "-";
    },
    openAddModal() {
      this.modal.visible = true;
      this.modal.data = {
        code: '',
        name: '',
        country: '',
        business_type: '',
        address: '',
        business_phone: '',
        fax: '',
        mobile_phone: '',
        email: '',
        contact_person: '',
        notes: ''
      };
      this.modal.errorMessage = {};
      this.modal.title = 'Add Manufacturer';
      this.modal.editId = null;
    },
    async openEditModal(id) {
      this.modal.onLoading = true;
      try {
        const res = await api(this, manufacturerService.detail(id), false);
        const data = res?.data ?? null;
        if (!data) {
          this.$swal({ icon: 'error', title: 'Gagal mengambil data', text: 'Data tidak ditemukan.' });
          this.modal.onLoading = false;
          return;
        }
        this.modal.visible = true;
        this.modal.editId = id;
        this.modal.data = {
          code: data.code || '',
          name: data.name || '',
          country: data.country || '',
          business_type: data.business_type || '',
          address: data.address || '',
          business_phone: data.business_phone || '',
          fax: data.fax || '',
          mobile_phone: data.mobile_phone || '',
          email: data.email || '',
          contact_person: data.contact_person || '',
          notes: data.notes || ''
        };
        this.modal.errorMessage = {};
        this.modal.title = 'Edit Manufacturer';
      } finally {
        this.modal.onLoading = false;
      }
    },
    async save() {
      this.modal.errorMessage = {};
      if (!this.modal.data.code) this.modal.errorMessage['code'] = 'Code required';
      if (!this.modal.data.name) this.modal.errorMessage['name'] = 'Name required';
      if (Object.keys(this.modal.errorMessage).length > 0) return;

      const dataToSend = { ...this.modal.data };
      if (this.modal.editId) delete dataToSend.code;

      this.modal.onLoading = true;
      try {
        if (this.modal.editId) {
          await api(this, manufacturerService.patch(this.modal.editId, dataToSend), true);
        } else {
          await api(this, manufacturerService.create(dataToSend), true);
        }
        this.modal.visible = false;
        this.get();
      } catch (error) {
        if (error.response?.data?.code == 400 && error.response.data.data) {
          error.response.data.data.forEach((v) => {
            this.modal.errorMessage[v.path] = v.msg;
          });
        }
      } finally {
        this.modal.onLoading = false;
        this.modal.editId = null;
      }
    },
    closeModal() {
      this.modal.visible = false;
    },
    async deleteItem(id) {
      this.confirmDialog("You won't be able to revert this!", "delete it").then((result) => {
        if (result.isConfirmed) {
          api(this, manufacturerService.delete(id)).then(() => {
            this.get();
          });
        }
      });
    },
  },
};
</script>